import { useAvailableTimes } from "api/api-hooks/use-available-times";
import { DetailsWithPaymentForm } from "components/details-form/details-with-payment-form";
import { DetailsWithPaymentFormSkeleton } from "components/details-form/details-with-payment-form-skeleton";
import { useBookingStateContext } from "hooks/use-booking-state";

const DetailsFormWrapper = () => {
    const state = useBookingStateContext();
    const availableTimes = useAvailableTimes(state.date);

    if (availableTimes.isPending) return <DetailsWithPaymentFormSkeleton />;

    return <DetailsWithPaymentForm />;
};

export default DetailsFormWrapper;
